
import {Component, Vue} from "vue-property-decorator";
import {ICar} from "@/modules/Car/interfaces/car.interface";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {IBook} from "@/interfaces/book.interface";
import {IAppState} from "@/interfaces/app-state.interface";
import {accountResource} from "@/modules/Profile/resources/accounts.resource";

@Component({})
export default class EmailAndAccountField extends Vue {

  get storeState(): IAppState { return this.$store.state; }
  get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
  get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }

  get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
  get viewMode() { return !this.userAccess.scCarMk; }
  get corps(): IBook.CorpBookItem[] { return this.$store.getters['car/carInfoBookCorps']; }

  get modelValue() { return this.formModel.email; }
  set modelValue(value) {
    this.$store.commit('car/setFormProperty', {
      formName: 'formModel',
      name: 'email',
      value
    });
  };

  get disableCreateAccount() {
    const isPersNameValid = !!this.formModel.persName;
    const isCorpValueValid = !!this.formModel.corpId || !!this.formModel.corpName;
    const isCorpValid = !this.userAccess.extModeFlag
      || !this.userAccess.scCorpAdmin
      || (this.userAccess.scCorpAdmin && this.userAccess.extModeFlag && isCorpValueValid);
    const hasEmailOrPhone = !!this.formModel.email || !!this.formModel.phone;
    return !(isPersNameValid && isCorpValid && hasEmailOrPhone);
  }


  async createAccount() {
    let payload: any = {};
    const fields = ['persName', 'email', 'phone',];
    fields.forEach(field => payload[field] = this.formModel[field]);
    if (!!this.formModel.corpId && !Boolean(this.formModel.corpName)) {
      const corp = this.corps.find(item => item.id === this.formModel.corpId);
      if (corp) {
        this.$store.commit('car/setFormProperty', {
          formName: 'formModel',
          name: 'corpName',
          value: corp.name,
        });
      }
    }
    const optionalParams = ['corpName', 'corpId',];
    optionalParams.forEach((item) => { if (this.formModel[item]) payload[item] = this.formModel[item]; });
    if (this.formModel.corpId) {
      this.$store.commit('car/setFormProperty', {formName: 'formModel', name: 'corpName', value: null,});
    }
    let response = await accountResource.createAccount(payload);
    if (response.success) {
      this.$notify({
        title: 'Успешно',
        message: response.response.message,
        type: 'success'
      });
    }
    else {
      this.$notify.error({
        title: 'Ошибка',
        message: response.error.message,
      });
    }
  }

}
